import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Loading } from "./components/kit";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import SelectStore from "./pages/SelectStore";
import MyPerformance from "./pages/MyPerformance";
import DailyEntry from "./pages/DailyEntry";
import MyEntries from "./pages/MyEntries";
import Account from "./pages/Account";
import Dashboard from "./pages/Dashboard";
import StaffDetail from "./pages/StaffDetail";
import Team from "./pages/Team";
import Stores from "./pages/Stores";
import Targets from "./pages/Targets";
import Reports from "./pages/Reports";
import AuditLogs from "./pages/AuditLogs";
import Settings from "./pages/Settings";
import Returns from "./pages/Returns";
import Gms from "./pages/Gms";
import MtoTracker from "./pages/MtoTracker";

function Guard({ roles, children }) {
  const { user, storeId, settings } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (!settings) return <Loading />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (user.role === "manager" && !storeId) return <Navigate to="/select-store" replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "staff" ? "/me" : "/dashboard"} replace />;
}

const MA = ["admin", "manager"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/select-store" element={<SelectStore />} />
            <Route path="/me" element={<Guard roles={["staff"]}><MyPerformance /></Guard>} />
            <Route path="/entry" element={<Guard roles={["staff"]}><DailyEntry /></Guard>} />
            <Route path="/history" element={<Guard roles={["staff"]}><MyEntries /></Guard>} />
            <Route path="/returns" element={<Guard><Returns /></Guard>} />
            <Route path="/gms" element={<Guard><Gms /></Guard>} />
            <Route path="/mto" element={<Guard roles={MA}><MtoTracker /></Guard>} />
            <Route path="/account" element={<Guard><Account /></Guard>} />
            <Route path="/dashboard" element={<Guard roles={MA}><Dashboard /></Guard>} />
            <Route path="/staff/:id" element={<Guard roles={MA}><StaffDetail /></Guard>} />
            <Route path="/team" element={<Guard roles={MA}><Team /></Guard>} />
            <Route path="/targets" element={<Guard roles={MA}><Targets /></Guard>} />
            <Route path="/reports" element={<Guard roles={MA}><Reports /></Guard>} />
            <Route path="/stores" element={<Guard roles={["admin"]}><Stores /></Guard>} />
            <Route path="/audit" element={<Guard roles={["admin"]}><AuditLogs /></Guard>} />
            <Route path="/settings" element={<Guard roles={["admin"]}><Settings /></Guard>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
